module.exports = __webpack_public_path__ + "img/pre_btn@3x.2f0bdbd7.png";